import { createRoute } from '@tanstack/react-router';
import { tourConfigRoute } from '@/features/dashboard/tourConfig/routes/tourConfigRoutes.ts';
import TourOptionsConfigPage from '@/features/dashboard/tourOptions/pages/TourOptionsConfigPage.tsx';

export const tourOptionsConfigRoute = createRoute({
  getParentRoute: () => tourConfigRoute,
  path: 'options',
  component: TourOptionsConfigPage,
});
